import { getCountryByCode } from '../../lib/constants'

interface CountryFlagProps {
  code: string
  showLabel?: boolean
}

export function CountryFlag({ code, showLabel = true }: CountryFlagProps) {
  const country = getCountryByCode(code)
  const flag = country?.flag || code
  const name = country?.name || code

  return (
    <span className="inline-flex items-center gap-1">
      <span className="text-sm">{flag}</span>
      {showLabel && (
        <span className="text-xs text-fn-text-sub">
          {name}
        </span>
      )}
    </span>
  )
}
